<div id="cookie-consent" class="cookie-consent-popup-container" *ngIf="!cookieSettings?.accepted && isBrowser">
  <div class="cookie-consent-popup-title" [attr.data-translate]="'cookie.consent.popup.title'" i18n="@@cookie.consent.popup.title">Cookies consent</div>

  <div class="cookie-consent-popup-message" [attr.data-translate]="'cookie.consent.popup.message'">
    <span i18n="@@cookie.consent.popup.message"
      >We use cookies on this site to improve your experience, for analytics and to deliver relevant advertising. Some
      are strictly necessary to run the site while others are optional.
    </span>
  </div>
  <div class="buttons">
    <div class="cookie-consent-popup-accept">
      <p (click)="acceptAll()" i18n="@@cookie.consent.popup.button.acceptAll" [attr.data-translate]="'cookie.consent.popup.button.acceptAll'">Accept all</p>
    </div>

    <div class="cookie-consent-popup-accept">
      <p (click)="rejectAll()" i18n="@@cookie.consent.popup.button.rejectAll" [attr.data-translate]="'cookie.consent.popup.button.rejectAll'">Reject all</p>
    </div>
  </div>

  <div class="cookie-consent-popup-customize">
    <a (click)="showCookieCustomizationDialog()" i18n="@@cookie.consent.popup.button.customize" [attr.data-translate]="'cookie.consent.popup.button.customize'">Customize settings</a>
  </div>
</div>

<p-dialog
  [(visible)]="displayCookieDialog"
  [modal]="true"
  [style]="{ width: '50vw' }"
  [baseZIndex]="10000"
  [draggable]="false"
  [resizable]="false"
  [closable]="false"
  header="Customize cookie preferences"
  i18n-header="@@cookie.consent.dialog.title"
>
  <div class="cookie-settings-content">
    <div class="cookie-settings-msg" *ngIf="customCookiesMsg">{{ customCookiesMsg }}</div>
    <div class="cookie-settings-options">
      <div [class.highlight]="cookieSettings?.analytics_storage?.highlighted" class="cookie-setting-option">
        <span>
          <label i18n="@@cookie.consent.dialog.analytics_storage" [attr.data-translate]="'cookie.consent.dialog.analytics_storage'">Analytics cookies</label>
          <fa-icon
            [icon]="faQuestionCircle"
            class="tooltip-icon"
            tooltipEvent="focus"
            tabindex="0"
            pTooltip="Measuring website load speeds and general site performance"
            i18n-pTooltip="@@cookie.consent.dialog.analytics_storage.tooltip"
            [attr.data-translate]="'cookie.consent.dialog.analytics_storage.tooltip'"
          ></fa-icon>
        </span>
        <p-inputSwitch [(ngModel)]="cookieSettings?.analytics_storage.enabled"></p-inputSwitch>
      </div>

      <div
        *ngIf="joinedTargetingPlatforms"
        [class.highlight]="cookieSettings?.ad_storage?.highlighted"
        class="cookie-setting-option"
      >
        <span>
          <label i18n="@@cookie.consent.dialog.ad_storage"  [attr.data-translate]="'cookie.consent.dialog.ad_storage'">Targeting cookies</label>
          <fa-icon
            tooltipEvent="focus"
            tabindex="0"
            [icon]="faQuestionCircle"
            class="tooltip-icon"
            pTooltip="Third Party Cookies used by advertisers to serve you with advertising on other platforms. They may be from Social media platforms or other advertising platforms."
            i18n-pTooltip="@@cookie.consent.dialog.ad_storage.tooltip"
            [attr.data-translate]="'cookie.consent.dialog.ad_storage.tooltip'"
          ></fa-icon>
        </span>
        <p-inputSwitch [(ngModel)]="cookieSettings?.ad_storage.enabled"></p-inputSwitch>
      </div>

      <div [class.highlight]="cookieSettings?.functionality_storage?.highlighted" class="cookie-setting-option">
        <span>
          <label i18n="@@cookie.consent.dialog.functionality_storage" [attr.data-translate]="'cookie.consent.dialog.functionality_storage'">Functionality cookies</label>
          <fa-icon
            [icon]="faQuestionCircle"
            class="tooltip-icon"
            tooltipEvent="focus"
            tabindex="0"
            pTooltip="Enables storage that supports the functionality of the website or app e.g. language settings, trailer views."
            i18n-pTooltip="@@cookie.consent.dialog.functionality_storage.tooltip"
            [attr.data-translate]="'cookie.consent.dialog.functionality_storage.tooltip'"
          ></fa-icon>
        </span>
        <p-inputSwitch [(ngModel)]="cookieSettings?.functionality_storage.enabled"></p-inputSwitch>
      </div>

      <div
        *ngIf="allowLoginChange"
        [class.highlight]="cookieSettings?.social_login?.highlighted"
        class="cookie-setting-option"
      >
        <span>
          <label i18n="@@cookie.consent.dialog.social_login"  [attr.data-translate]="'cookie.consent.dialog.social_login'">Social Networks Login cookies</label>
          <fa-icon
            [icon]="faQuestionCircle"
            class="tooltip-icon"
            tooltipZIndex="11002"
            tooltipPosition="top"
            tooltipEvent="focus"
            tabindex="0"
            pTooltip="Support for logging in with Google or Facebook."
            i18n-pTooltip="@@cookie.consent.dialog.social_login.tooltip"
            [attr.data-translate]="'cookie.consent.dialog.social_login.tooltip'"
          ></fa-icon>
        </span>
        <p-inputSwitch [(ngModel)]="cookieSettings?.social_login.enabled"></p-inputSwitch>
      </div>

      <div [class.highlight]="cookieSettings?.security_storage?.highlighted" class="cookie-setting-option">
        <span>
          <label i18n="@@cookie.consent.dialog.security_storage" [attr.data-translate]="'cookie.consent.dialog.security_storage'">Security cookies</label>
          <fa-icon
            [icon]="faQuestionCircle"
            class="tooltip-icon"
            tooltipEvent="focus"
            tabindex="0"
            pTooltip="Enables storage related to security such as authentication functionality, fraud prevention, and other user protection"
            i18n-pTooltip="@@cookie.consent.dialog.security_storage.tooltip"
            [attr.data-translate]="'cookie.consent.dialog.security_storage.tooltip'"
          ></fa-icon>
        </span>
        <p-inputSwitch [(ngModel)]="cookieSettings?.security_storage.enabled"></p-inputSwitch>
      </div>

      <div class="cookie-setting-option">
        <span>
          <label i18n="@@cookie.consent.dialog.strictly.necessary"  [attr.data-translate]="'cookie.consent.dialog.strictly.necessary'"> Strictly necessary</label>
          <fa-icon
            [icon]="faQuestionCircle"
            class="tooltip-icon"
            tooltipEvent="focus"
            tabindex="0"
            pTooltip="These cookies are the core ones to enable the functionality of the site. They are used to remember your location if you have given it, which allows us to show you relevant film, showtime and streaming information. For sites with log in functionality, cookies are used to remember your account."
            i18n-pTooltip="@@cookie.consent.dialog.strictly.necessary.tooltip"
            [attr.data-translate]="'cookie.consent.dialog.strictly.necessary.tooltip'"
          ></fa-icon>
        </span>
        <p-inputSwitch [disabled]="true" [ngModel]="true"></p-inputSwitch>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="cookie-settings-footer">
      <span></span>
      <p-button
        [text]="true"
        label="Cancel"
        i18n-label="@@cookie.consent.dialog.footer.discard"
        [attr.data-translate]="'cookie.consent.dialog.footer.discard'"
        (click)="cancelSettings()"
      >
      </p-button>
      <p-button [text]="true" label="Accept" i18n-label="@@cookie.consent.dialog.footer.accept" [attr.data-translate]="'cookie.consent.dialog.footer.accept'" (click)="acceptChoices()"> </p-button>
    </div>
  </ng-template>
</p-dialog>
